import IconButton from '@mui/material/IconButton'
import { RefreshLineIcon } from 'components/icons'
import { RefreshButtonProps } from './types'
import useRefresh from './useRefresh'

import styles from './refresh.module.css'

export default function RefreshButtonMui( { refetchFunction }: RefreshButtonProps ) {
	const { isSpinning, onClick } = useRefresh( refetchFunction )

	return (
		<IconButton
			className={isSpinning ? styles.spinning : undefined}
			aria-label="Refresh"
			onClick={onClick}
		>
			<RefreshLineIcon />
		</IconButton>
	)
}
